document.addEventListener('DOMContentLoaded', () => {
    const menu = document.querySelector('#mega-menu-main-menu');
    const mobileContainer = document.querySelector('.menu-container--mobile');
    const header = document.querySelector('.main-header');

    if (!menu) {
        return;
    }

    const addBackLink = (item) => {
        if (item.querySelector('.menu-back-link')) {
            return;
        }

        const backLink = document.createElement('li');

        backLink.className = 'menu-back-link';
        backLink.innerHTML = '<a href="#">Retour</a>';

        backLink.addEventListener('click', (e) => {
            e.preventDefault();

            item.classList.remove('mega-toggle-on');
        });

        const subMenu = item.querySelector('.mega-sub-menu');

        if (subMenu) {
            subMenu.prepend(backLink);
        }
    };

    const refreshMenuState = () => {
        const openedItems = menu.querySelectorAll('.mega-menu-item.mega-toggle-on');

        openedItems.forEach(addBackLink);

        if (header) {
            header.classList.toggle('menu-is-open', openedItems.length > 0);
        }
    };

    const observer = new MutationObserver(refreshMenuState);

    observer.observe(menu, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class'],
    });

    refreshMenuState();

    document.addEventListener('click', (e) => {
        const trigger = e.target.closest('.menu-mobile');

        if (!trigger || !mobileContainer) {
            return;
        }

        mobileContainer.classList.toggle('menu-open');
    });
});
document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.main-header');

    if (!header) {
        return;
    }

    const updateHeader = () => {
        const hasOpenMenu = document.querySelector('.mega-menu-item-has-children.mega-toggle-on');

        header.classList.toggle('menu-is-open', !!hasOpenMenu);
    };

    const observer = new MutationObserver(updateHeader);

    document.querySelectorAll('.mega-menu-item-has-children').forEach(item => {
        observer.observe(item, {
            attributes: true,
            attributeFilter: ['class']
        });
    });

    updateHeader();
});